import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
  Observable,
} from '@apollo/client'
import { networkActivityLink } from './network-activity-link'
import { env } from '@/env'
import {
  isCustomerAuthError,
  notifyCustomerAuthSessionExpired,
} from '@/shared/lib/customer-auth'

const httpLink = new HttpLink({
  credentials: 'include',
  uri: env.VITE_GRAPHQL_URL,
})

const customerAuthLink = new ApolloLink((operation, forward) => {
  return new Observable((observer) => {
    const subscription = forward(operation).subscribe({
      complete: () => observer.complete(),
      error: (error: unknown) => {
        if (isCustomerAuthError(error)) {
          notifyCustomerAuthSessionExpired()
        }

        observer.error(error)
      },
      next: (result) => {
        if (isCustomerAuthError(result.errors)) {
          notifyCustomerAuthSessionExpired()
        }

        observer.next(result)
      },
    })

    return () => subscription.unsubscribe()
  })
})

const client = new ApolloClient({
  link: ApolloLink.from([customerAuthLink, networkActivityLink, httpLink]),
  cache: new InMemoryCache(),
})

export default client
